export default __webpack_public_path__ + "static/media/coffee-break.bcfe6265.png";